<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
  import Vue from 'vue';
  import { NavBar } from 'vant';
  Vue.component(NavBar.name, NavBar);

  export default {
    name: 'app'
  }
</script>

<style type="text/less" lang="less">
  @import "common/less/mixin.less";
  @import "common/less/global";
  html {
    width: 100%;
    font-size: 32px;/*px*/
    background-color: #f1f1f1;
  }
  #app {
    -moz-user-select: none;
    -webkit-user-select: none;
    font-size: 32px;/*px*/
    -webkit-text-size-adjust: 100%!important;
    min-width:290px;
    // box-shadow: #7a7a7a 1px 1px 10px;
    font-family: SourceHanSansCN-Regular,system,-apple-system,"Helvetica Neue","PingHei","Heiti SC",sans-serif;
    width:100%;
    margin: auto;
    min-height: 100%;
  }
  #app>img {
    display: block;
    width: 100%;
  }
  #app>pre {
    margin: 0;
    padding: 0.9375rem;
    color: #333;
    font-size: 0.9375rem;
    line-height: 1.5;
    white-space: pre-wrap;
    font-family: system,-apple-system,"Helvetica Neue","PingHei","Heiti SC",sans-serif;
  }
  #app>#navbar{
    background-color: #11bdff;
    position: fixed;
    top:0;
    left:0;
    right:0;
    line-height:2.375rem;
    z-index: 999;
    text-align: center;
  }
  #app>#navbar>button{
    background:transparent;
    border: none;
    color: white;
    padding: 5px 10px;
    text-align: center;
    text-decoration: none;
    display: inline-block;
    font-size: 32px;/*px*/
    
  }
  #app>#navbar>#title{
    color: white;
    padding: 5px 10px;
    text-align: center;
    display: inline-block;
    font-size: 36px;/*px*/
    font-weight: 500;
  }
</style>



// WEBPACK FOOTER //
// App.vue?46a158a3